import React, {useState, useEffect} from 'react'
import {Row, Col, Input, Button, Card, CardBody } from 'reactstrap'
import logo from '../Assets/logo.png';
import * as moment from 'moment'

export default function DateTimePickerComponent({accentColor, secondaryColor, setStep, logoSrc, mainText, startingHour, endingHour, skipWeekends, setDate}){

    const [hoursState, setHoursState] = useState([]);
    const [daysState, setDaysState] = useState([]);
    const [selectedDay, setSelectedDay] = useState('');
    const [selectedHour, setSelectedHour] = useState('');
    

    function getDays(){
        let dates = [];
        let todayIsWeekend = moment().day() === 6 || moment().day() === 0;
        if(moment().hour() < endingHour && !(skipWeekends && todayIsWeekend)){                        
            dates.push(moment().format("YYYY-MM-DD"));                     
        }
        
        let tommorow = moment().add(1, 'days');
        let tommorowIsWeekend = tommorow.day() === 6 || tommorow.day() === 0;

        if(!(tommorowIsWeekend && skipWeekends)){            
            dates.push(tommorow.format("YYYY-MM-DD"));
        }   
        
        let iterator = 0;
        while(dates.length < 5){
            let day = moment().add(iterator + 2, 'day');    
            if(!((day.day() === 6 || day.day() === 0) && skipWeekends)){                                
                dates.push(day.format("YYYY-MM-DD"));
            }
            iterator++;
        }
        setDaysState(dates);
        return dates;
    }

    function calculate(startTime, endTime) {
        var timeStops = [];
            
        while(startTime <= endTime){
            timeStops.push(new moment(startTime));
            startTime.add('m', 15);
        }    
        return timeStops;
    }

    function getHours(forDay){
        let hours = [];    
        var endTime = moment(forDay, 'YYYY-MM-DD');
        
        const roundedUp = Math.ceil(moment().minute() / 15) * 15;
        var startTime = moment(forDay, 'YYYY-MM-DD').hour(moment().get('hour')).minute(roundedUp).second(0); 
        if(startTime.date() > moment().date()){
            startTime.set({hour: startingHour, minute:0, second:0});
        }else if(startTime.hour() < startingHour){
            startTime.set({hour: startingHour, minute:0, second:0});
        }
        endTime.set({hour:endingHour,minute:0,second:0,millisecond:0});    
        let moments = calculate(startTime, endTime);
        for(let i = 0; i < moments.length; i++){
            hours.push(moments[i].format('HH:mm'));
            if(i === 0) {
                setSelectedHour(moments[i].format('HH:mm'));
            }
        }
        setHoursState(hours);
        setDate(forDay  + " " + hours[0]);
        setSelectedDay(forDay);
        return hours;
    }

    function renderHours(){
        let result = [];
        for(var i = 0; i < hoursState.length; i++){
            result.push(<option value={hoursState[i]}>{hoursState[i]}</option>)
        }
        return result;
    }

    function renderDays(){
        let result = [];
        for(var i = 0; i < daysState.length; i++){
            if(daysState[i] === moment().format("YYYY-MM-DD")){
                result.push(<option value={daysState[i]}>Dzisiaj</option>);
            } else if (daysState[i] === moment().add(1, 'days').format("YYYY-MM-DD")){
                result.push(<option value={daysState[i]}>Jutro</option>);
            }
            else{
                result.push(<option value={daysState[i]}>{daysState[i]}</option>)
            }
        }
        return result;
    }

    useEffect(() => {        
        getHours(getDays()[0])
    }, [])
    

    return(        
           <Card>
                        <CardBody>
                            <div className="centered-div">
                                <img className="small-logo" src={logoSrc ? logoSrc : logo}></img>
                            </div>                            
                            <div className="centered-div big-text">
                                {mainText}
                            </div>
           <Row className="button-strip">
               <Col>
                <Input type="select" onChange={(e) => { getHours(e.target.value)} }>
                    {renderDays()}
                </Input>
               </Col>
               <Col>
               <Input type="select" value={selectedHour} onChange={(e) => {
                   setSelectedHour(e.target.value);
                   setDate(selectedDay + " " + e.target.value)
                }}>
                   {renderHours()}
               </Input>
               </Col>
           </Row>
           <Row className="button-strip">
                <Col>
                    <Button onClick={() => { setStep("end")}} style={{backgroundColor: accentColor, color: secondaryColor}} className="mr-2">Zadzwoń później</Button>
                </Col>
            </Row>
            </CardBody>
        </Card>
    )
}